import Schrank from "./Schrank";
import ShojituerFluegel from "./ShojituerFluegel";
import Commons from "oc-commons/Commons";
import type {HasLocalCoordinates} from "./HasLocalCoordinates";
import Brett from "./Brett";
import Interieur from "./Interieur";
import ShojituerO3 from "../object3d/Shojituer";

export default class Shojituer implements HasLocalCoordinates {

    product: ?Object;
    fluegel: ?ShojituerFluegel[] = [];
    schrank: Schrank;
    object3d: ?THREE.Object3D;
    isClosed: boolean = true;

    constructor(schrank) {
        this.schrank = schrank;
        this.product = APP.findProduct('Shojituer');
    }

    get parent() {
        return this.schrank;
    }

    get child3dContainer() {
        return this.object3d;
    }

    getFrontOffset() {
        return APP.settings.getFloat('schiebetuer_vorsprung', 8);
    }

    schrankToLocal(v: THREE.Vector3) {
        return this.schrank.schrankToLocal(v);
    }

    localToSchrank(v: THREE.Vector3) {
        return this.schrank.localToSchrank(v);
    }

    fromJSON(json) {
        if (json) {
            this.fluegel = Commons.mapreuse(json.fuegel, this.fluegel, e => new ShojituerFluegel(this), (d, s) => d.fromJSON(s));
        }
        return this;
    }

    toJSON() {
        return {
            fuegel: this.fluegel.map(f => f.toJSON()),
        };
    }

    copy(shojituer,createInterceptor) {
        this.product = shojituer.product;
        this.fluegel = Commons.mapreuse(shojituer.ShojituerFluegel,this.fluegel,(s)=>new ShojituerFluegel(this),(d,s)=>d.copy(s,createInterceptor));
        return this;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new ShojituerO3(this);
            this.schrank.child3dContainer.add(o3);
            return o3;
        });
        this.fluegel = Commons.mapreuse(this.schrank.elements, this.fluegel, e=>new ShojituerFluegel(this), (d,s) => d);
        this.fluegel.forEach(f => f.compile());

    }

    iterate(iterator) {
        iterator(this);
        this.fluegel.forEach(x=>x.iterate(iterator));
    }

    showClosed(close, time) {
        if (close === this.isClosed) return;
        this.isClosed = close;
        this.object3d.animate({
            opacity: close ? 1 : 0,
            duration: time,
            onStart: () => {
                this.object3d.visible = !close;
            },
            onComplete: () => {
                this.object3d.visible = close;
            },
        });
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

}

